import { useEffect } from "react";
import { useSitePath } from "../context/SiteContext";
import { SearchCard } from "./home/parts";

const toQuery = (f) => new URLSearchParams({
  arrival: f.arrival, nights: f.nights, rooms: f.rooms, adults: f.adults, kids: f.kids || 0,
  ...(f.promo ? { promo: f.promo.trim() } : {}), show_packages: f.show_packages ? 1 : 0, packages_only: f.packages_only ? 1 : 0,
}).toString();

export default function SearchWidget() {
  const sp = useSitePath();
  const onSearch = (form) => {
    if (window.self === window.top) return window.location.assign(`${sp("/hotels")}?${toQuery(form)}`);
    window.parent.postMessage({ type: "eres-booking-search", query: toQuery(form) }, "*");
  };
  useEffect(() => {
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
  }, []);
  return (
    <div className="p-1" data-testid="search-widget">
      <SearchCard onSearch={onSearch} className="shadow-[0_20px_60px_-30px_rgba(0,0,0,.45)]" />
    </div>
  );
}
